module.exports = __webpack_public_path__ + "src/assets/img/photo_staubli2.fe1accb6.jpg";